<template>
	<div class="sdk_initaial">
		<document-title-bar :pathData="isPathData"></document-title-bar>
		<h1 class="doc_main_h1">开启人脸注册</h1>
		<h3 class="doc_main_h3">功能描述</h3>
		<p class="doc_main_p">
			开启本地人脸注册流程。
		</p>
		<h3 class="doc_main_h3">函数</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">public void SKFaceStartRegPerson(int RegModel,  String PersonName,  
int PersonSex, int BirthYear, int BirthMonth, int BirthDay, 
String DetailsInfo, String GroupsID, 
int StartX, int StartY, int Width, int Height, 
final RegPersonCallbackInterface RegPersonCallback) </code></pre>
		<h3 class="doc_main_h3">参数</h3>
        <p class="doc_main_p">
             <p class="doc_main_p">（1）RegModel：注册模式：0：快速注册（默认值）、1：标准注册、2：精准注册，其他值默认为0</p>
             <p class="doc_main_p">（2）PersonName：注册人姓名</p>
             <p class="doc_main_p">（3）BirthDay：注册人生日-几日（传入0，为默认值）</p>
             <p class="doc_main_p">（4）DetailsInfo：细节信息（其他备注信息，可为空）</p>
             <p class="doc_main_p">（5）GroupsID：注册人员组ID（人员组id用“,”隔开，“”为默认值，例如：”2001，2002”，表示当前人注册到人员组id为2001、2002的分组下，
                                            默认分组为当前设备所关联全部分组，如果没有关联人员组会创建一个分组）</p>
             <p class="doc_main_p">（6）StartX：有效注册区域的起点坐标x值（请注意转换为Camera分辨率对应值）</p>
             <p class="doc_main_p">（7）StartY：有效注册区域的起点坐标y值（请注意转换为Camera分辨率对应值）</p>
             <p class="doc_main_p">（8）Width：从(StartX, StartY)点向右Width为有效注册区域（请注意转换为Camera分辨率对应值）</p>
             <p class="doc_main_p">（9）Height：从(StartX, StartY)点向下Height为有效注册区域（请注意转换为Camera分辨率对应值）</p>
             <p class="doc_main_p">（10）RegPersonCallback：注册回调：包括注册状态、注册进度信息
                                    //Code 状态码；Msg 状态消息；PersonInfo 注册成功Person信息
                                    RegPersonStateCallback(int Code, String Msg, String PersonInfo); 
                                    // 注册进度信息
                                    RegPersonProgressInfoCallback(String RegisterProgressInfo); 
                                    RegisterProgressInfo：格式为37个int值（0/1）组成的数组json串 
</p>
        </p>
        <h3 class="doc_main_h3">返回值</h3>
        <p class="doc_main_p">（1）注册结果</p>
		<register-result-table></register-result-table>
        <p class="doc_main_p">（2）注册相关错误码列表</p>
		<register-interfix-error-table></register-interfix-error-table>
		<h3 class="doc_main_h3">示例代码</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">skFace.SKFaceStartRegPerson(1, "王", 1, 1994, 9, 27, "", "2001,2002",0, 0, 640, 480, new RegPersonCallbackInterface() {
    @Override
    public void RegPersonStateCallback(int Code, String Msg, 
String PersonInfo) {
        // TODO:在这里处理注册状态变化
    }
    @Override
    public void RegPersonProgressInfoCallback(String RegisterProgressInfo) {
        // TODO:此处是注册进度信息的返回值      
    }
});</code></pre>
	</div>
</template>
<script>
	import DocumentTitleBar from '../../../../components/documentTitleBar';
	import AuthorityErrorCode from '../../../../components/authorityErrorCode';
import registerResultTable from '../../../../components/registerResultTable.vue';
import registerInterfixErrorTable from '../../../../components/registerInterfixErrorTable.vue';

	export default{
		components:{
			'document-title-bar':DocumentTitleBar,
			'authority-error-code':AuthorityErrorCode,
			'register-result-table':registerResultTable,
			'register-interfix-error-table':registerInterfixErrorTable,
		},
		data(){
			return{
				isPathData:['人脸识别','SKFaceLive-Android','视频接口','开启人脸注册'],
			}
		},
		watch:{

		},
		methods:{

		},
		mounted(){

		}
	}
</script>
<style lang="less" rel="stylesheet/less">
	@import '../../../../less/index.less';
	.sdk_initaial{
	}
</style>	


// WEBPACK FOOTER //
// src/views/documents/skfacesdklive/voideinitiali/VoideFaceregister.vue